module.exports = __webpack_public_path__ + "media/ding.9b951a1b.mp3";